import { SVGFC } from '@repo/toolkit/types'

const ActivateIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_4990_125378)">
        <path
          d="M18.3554 5.64458C14.8299 2.11907 9.17125 2.11788 5.64458 5.64458C2.11907 9.17006 2.11788 14.8287 5.64458 18.3554C9.17006 21.8809 14.8287 21.8821 18.3554 18.3554C21.8809 14.83 21.8821 9.17125 18.3554 5.64458ZM12 19.9437C7.6198 19.9437 4.05625 16.3802 4.05625 12C4.05625 7.6198 7.6198 4.05625 12 4.05625C16.3802 4.05625 19.9437 7.6198 19.9437 12C19.9437 16.3802 16.3802 19.9437 12 19.9437Z"
          fill={color}
        />
        <path
          d="M14.5886 9.08108C14.3708 8.88779 14.0376 8.90765 13.8443 9.12547C13.651 9.34326 13.6709 9.67651 13.8887 9.86979C14.4976 10.4102 14.8468 11.1867 14.8468 12.0001C14.8468 13.57 13.5697 14.8472 11.9998 14.8472C10.4298 14.8472 9.15266 13.57 9.15266 12.0001C9.15266 11.1786 9.5077 10.3971 10.1267 9.8558C10.3459 9.66413 10.3683 9.33106 10.1766 9.11183C9.98489 8.89261 9.65181 8.87032 9.43259 9.06199C8.58454 9.8035 8.09814 10.8744 8.09814 12.0001C8.09814 14.1514 9.84837 15.9017 11.9997 15.9017C14.1511 15.9017 15.9013 14.1514 15.9013 12.0001C15.9013 10.8854 15.4229 9.82146 14.5886 9.08108Z"
          fill={color}
        />
        <path
          d="M11.9999 11.1213C12.2911 11.1213 12.5271 10.8852 12.5271 10.5941V7.78212C12.5271 7.49095 12.2911 7.25488 11.9999 7.25488C11.7087 7.25488 11.4727 7.49095 11.4727 7.78212V10.5941C11.4727 10.8853 11.7087 11.1213 11.9999 11.1213Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_4990_125378">
          <rect width="18" height="18" fill={color} transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ActivateIcon
